import axiosConfig from '../../../../../config/axiosConfig';
import { ReceivedMoneyOffset } from '../../entity/Entity';

const CM017_2Api = () => {
    const getListOutsourceCostOffset = async (params: any): Promise<any> => {
        try {
            const url = '/re-summary/company/outsource-cost/offset/list';
            const response = await axiosConfig.get(url, { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const getSubCategory = async (): Promise<any> => {
        try {
            const url = '/money/received-money-offset/sub-category';
            const response = await axiosConfig.get(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const createReceivedMoneyOffset = async (data: any): Promise<any> => {
        try {
            const url = '/money/received-money-offset/create';
            const response = await axiosConfig.post(url, { data });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const deleteReceivedMoneyOffset = async (data: any): Promise<any> => {
        try {
            const url = '/money/received-money-offset/delete';
            const response = await axiosConfig.delete(url, { data });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const editReceivedMoneyOffset = async (data: any): Promise<any> => {
        try {
            const url = '/re-summary/company/outsource-cost/offset/edit';
            const response = await axiosConfig.post(url, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    return {
        getListOutsourceCostOffset,
        getSubCategory,
        createReceivedMoneyOffset,
        deleteReceivedMoneyOffset,
        editReceivedMoneyOffset,
    };
};

export default CM017_2Api;
